import React, { useState, useEffect } from "react";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import "./index.css";
import axios from 'axios';

function CustomerReviews() {
    const [recommendation, setRecommendation] = useState(null);
    const [ratings, setratings] = useState(null);

    useEffect(() => {
        async function fetchData() {
            try {
                const response = await axios.get(process.env.REACT_APP_RATINGS_JSON);
                const recommendationData = response.data.displayData.recommendation;
                const ratings = response.data.displayData.review.average;
                setRecommendation(recommendationData);
                setratings(ratings);
            } catch (error) {
                console.error('Error fetching data:', error);
            }
        }

        fetchData();
    }, []);

    // Separate the numeric rating part from the text "out of 5"
    const formattedRating = ratings ? ratings.toString().split(" ")[0] : null;

    return (
        <section className="CustomerReviews-section">
            <Container className="CustomerReviews-container">
                <h1 className="CustomerReviews-heading">Customer Reviews</h1>
                <p className="CustomerReviews-para">
                    We care deeply about our customers and their experience with us. <br />
                    See what people are saying about working with us!
                </p>
                <Row className="CustomerReviews-row">
                    <Col lg={5} md={12} sm={12} className="CustomerReviews-column1">
                        <p className="CustomerReviews-recommendation-percentage">{recommendation}</p>
                        <div className="progresss_bar">
                            <div className="progresss_bar_inner" style={{ width: `${recommendation}%` }} />
                        </div>
                        <p className="CustomerReviews-recommendation">
                            Would recommend Sun West Mortgage <br />Company, Inc. to friends and family
                        </p>
                    </Col>
                    {/* <Col lg={2} md={0} sm={0} className="CustomerReviews-blankcol"></Col> */}
                    <Col lg={5} md={12} sm={12} className="CustomerReviews-column2">
                        <div className="stars_container">
                            <div>
                                <div className="stars_base">★★★★★</div>
                                <div className="stars_fill">★★★★★</div>
                            </div>
                        </div>
                        <p className="CustomerReviews-ratings">
                            <span style={{ color: '#FFAD03' }}>{formattedRating}</span> out of 5
                        </p>
                        <p className="CustomerReviews-avg">Average customer review</p>
                    </Col>
                </Row>
            </Container>
        </section>
    );
}

export default CustomerReviews;
